import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import CollapsibleFilterOption from './collapsible-filters';
import FilterOption from './filter-options';

const FilterList = ({ 
    filterOptions, 
    selectedFilters,  
    onToggleFilter=() => {}, 
    onToggleSubOption=() => {}
}) => {

    const [expandedOptions, setExpandedOptions] = useState({});

    const toggleOptionExpansion = (optionId) => {
        setExpandedOptions(prev => ({
            ...prev,
            [optionId]: !prev[optionId]
        }));
    };

    const [showCustomComponent, setShowCustomComponent] = useState(null);

    useEffect(() => {
        return () => {
            setShowCustomComponent(null);
        };
    }, []);

    return (
        <ul className="flex flex-col gap-2">
            {filterOptions?.map((option) => {
                // renders custom component
                if (option?.CustomComponent) {
                    return (
                        <li key={"custom-component-"+option?.id} className='shadow-sm h-full' onClick={() => setShowCustomComponent(option?.name)}>
                            <span  className={'cursor-pointer text-16x ' + (showCustomComponent === option.name ? 'font-semibold' : '')} >{option?.symbol} {t(option?.name)}</span>
                            <div className='mt-2 h-full'>
                            {showCustomComponent === option.name ? option.CustomComponent : null}
                            </div>
                        </li>
                    );
                }
                // Handle simple filters (no nested options)
                if (!option?.options) {
                    const isSelected = selectedFilters?.includes(option?.name);
                    return (
                        <FilterOption
                            key={"filter-"+option?.id}
                            option={option}
                            isSelected={isSelected}
                            onToggle={() => onToggleFilter(option?.name, isSelected)}
                        />
                    );
                }
                
                // Handle complex filters with nested options
                const isExpanded = expandedOptions[option?.id];
                return (
                    <CollapsibleFilterOption
                        key={"collapsible-"+option?.id}
                        option={option}
                        isExpanded={isExpanded}
                        selectedFilters={selectedFilters}
                        onToggleExpansion={() => toggleOptionExpansion(option?.id)}
                        onToggleSubOption={onToggleSubOption}
                    />
                );
            })}
        </ul>
    );
};

export default FilterList;
